import {
    apiRequest,
    employeeWFHListdetail,
    employeeWFHInactive,
    employeeWFHActive
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", employeeWFHListdetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", employeeWFHInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", employeeWFHActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository